/**
 * Imperative navigation for thunks, API interceptors, and other non-component code.
 * Replaces preact-router's route().
 */
let navigateFn;

export const setNavigate = (fn) => {
    navigateFn = fn;
};

/**
 * @param {string} to - Path or path with query string (e.g. `/login` or `/dash?type=x`)
 * @param {boolean} [replace=false] - Replace the current history entry
 */
export const route = (to, replace = false) => {
    if (navigateFn) {
        navigateFn(to, { replace });
        return true;
    }

    if (replace) {
        window.location.replace(to);
    } else {
        window.location.assign(to);
    }
    return true;
};
